export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#002B54] border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-14 flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
        <div className="flex items-center gap-3">
          <img src="/assets/im_logo.svg" alt="iMarketings.lv" className="h-10 w-10 rounded-full" />
          <div>
            <p className="font-display font-bold tracking-tight text-white">iMarketings<span className="text-[#ED1C27]">.lv</span></p>
            <p className="text-xs text-white/40">Digitālā mārketinga aģentūra</p>
          </div>
        </div>
        <div className="text-sm text-white/45 space-y-1">
          <p>Google Ads&nbsp;&nbsp;•&nbsp;&nbsp;Meta Ads&nbsp;&nbsp;•&nbsp;&nbsp;SEO&nbsp;&nbsp;•&nbsp;&nbsp;Baneri&nbsp;&nbsp;•&nbsp;&nbsp;Video&nbsp;&nbsp;•&nbsp;&nbsp;UGC&nbsp;&nbsp;•&nbsp;&nbsp;AI kreatīvi</p>
          <p>
            <a href="https://imarketings.lv" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-testid="footer-site-link">
              imarketings.lv
            </a>
          </p>
        </div>
        <p className="text-xs text-white/30">© 2026 iMarketings.lv - Visas tiesības aizsargātas</p>
      </div>
    </footer>
  );
}
